import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';
import makeDeprecatedJadeStyleTemplate from 'util/makeDeprecatedJadeStyleTemplate';

interface SequenceSearchViewProps {
  searchLibrary: boolean;
}

function SequenceSearchView({searchLibrary}: SequenceSearchViewProps): JSX.Element {
  return (
    <div className="sequence-search-component">
      <div className="sequence-search-wrapper">
        {searchLibrary ? (
          <input type="text" placeholder="Search for a sequence or folder" className="search-input" />
        ) : (
          <input
            type="text"
            placeholder="Search for a sequence"
            className="search-input"
            {...getTestProps({component: 'SequenceSearch', element: 'sequenceSearchInput'})}
          />
        )}
        <div className="spinner hidden" />
      </div>
      <div className="sequence-search-results-wrapper">
        <div
          className="search-results list-group"
          {...getTestProps({component: 'SequenceSearch', element: 'searchResults'})}
        />
      </div>
    </div>
  );
}

export default makeDeprecatedJadeStyleTemplate<SequenceSearchViewProps>(SequenceSearchView);
